import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { OrderService } from '../../services/order/order.service';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/Rx';
import * as _ from 'lodash';

@Component({
  selector: 'rod-bag',
  templateUrl: './bag.component.html',
  styleUrls: ['./bag.component.scss'],
})
export class BagComponent implements OnInit, OnChanges {
  @Input() public bagIsActive: boolean;
  public bagIsEmpty: boolean = true;
  public bagItems;
  public itemAlertActive: boolean = false;
  public nameOnOrderIsActive: boolean = false;
  public creatingTicket: boolean = false;
  public tempRemoveItem: number;
  public nameForOrder: string = '';
  public pricing;
  public order;
  public employeeID;
  public tableID;
  public revenueCenterID;
  public orderTypeID;
  public nameOfOrder;
  public locationID;
  public ticketID;

  // To App Component
  @Output() public bagCloseEvent: EventEmitter<any> = new EventEmitter();

  constructor(private _orderService: OrderService, private _router: Router) {}

  ngOnInit() {
    this._orderService.orderSource.subscribe(order => (this.bagItems = order));
    this._orderService.orderPricingSource.subscribe(
      pricing => (this.pricing = pricing)
    );
    this._orderService.employeeID.subscribe(id => (this.employeeID = id));
    this._orderService.revenueCenterID.subscribe(
      id => (this.revenueCenterID = id)
    );
    this._orderService.tableID.subscribe(id => (this.tableID = id));
    this._orderService.orderType.subscribe(id => (this.orderTypeID = id));
    this._orderService.locationID.subscribe(id => (this.locationID = id));
    this._orderService.ticketID.subscribe(id => (this.ticketID = id));

    // console.log('bag items', this.bagItems);
  }

  ngOnChanges(changes) {
    // console.log('items', this.bagItems);
    // console.log('pricing', this.pricing);
  }

  public alertRemoveItem(itemID) {
    this.tempRemoveItem = itemID;
    this.itemAlertActive = true;
  }

  public cancelAlertRemoveItem() {
    this.itemAlertActive = false;
  }

  public increaseQuantityOfItem(item, index) {
    let itemID = item.menu_item;
    let increment = 1;
    let quantity = item.quantity + increment;
    console.log(quantity);
    this._orderService.updateItemQuantity(itemID, quantity, index);
  }

  public decreaseQuantityOfItem(item, index) {
    let itemID = item.menu_item;
    let increment = 1;
    let quantity = item.quantity - increment;
    if (quantity > 0) {
      this._orderService.updateItemQuantity(itemID, quantity, index);
    } else {
      this.alertRemoveItem(item.menu_item);
    }
  }

  public removeItem() {
    this._orderService.removeItemFromOrder(this.tempRemoveItem);
    this.itemAlertActive = false;
  }

  public closeBag() {
    if (this.bagIsActive) {
      this.bagIsActive = false;
      this.bagCloseEvent.emit({ bagIsActive: this.bagIsActive });
    }
  }

  public askForNameOnOrder() {
    console.log('HAS TICKET ID', sessionStorage.getItem('ticketID'));
    if (sessionStorage.getItem('ticketID')) {
      this.closeBag();
      const ticketID = sessionStorage.getItem('ticketID');
      this._router.navigate(['checkout', ticketID]);
    } else {
      this.nameOnOrderIsActive = !this.nameOnOrderIsActive;
    }
  }

  public clearBag() {
    sessionStorage.removeItem('ticketID');
    localStorage.removeItem('order');
    this._orderService.updateOrder(null);
    this._orderService.calculatePricing([]);
  }

  public checkout() {
    this.creatingTicket = true;
    const employeePOSID = '1998';
    this._orderService.getEmployeeByID(this.locationID).subscribe(
      result => {
        // console.log('employee', result);
        // let employee = _.filter(result, { pos_id: employeePOSID });
        let employee = result.filter(employee => {
          if (employee.pos_id === employeePOSID) {
            return employee;
          }
        });
        console.log(employee);
        this.orderTypeID = '5'; // Take out
        this.revenueCenterID = '1'; // Resturaunt
        this.tableID = '1';

        let ticket = {
          employee: employee[0].id,
          order_type: this.orderTypeID,
          revenue_center: this.revenueCenterID,
          table: this.tableID,
          guest_count: 1,
          name: this.nameOfOrder,
          auto_send: false,
        };

        console.log('ticket before send', ticket);

        this._orderService.openTicket(ticket, this.locationID).subscribe(
          result => {
            console.log('OPENED TICKET', result);
            this._orderService.updateTicketID(result.id);
            this.creatingTicket = false;
            this.nameOnOrderIsActive = false;
            this._orderService.updateTicket(result);
            this.closeBag();
            this._router.navigate(['/checkout', this.ticketID]);
          },
          error => {
            console.log('could not open a ticket', error);
          }
        );
      }
      // error => {
      //   console.log('could not get an employee', error);
      // }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/bag/bag/bag.component.ts